// extracted by mini-css-extract-plugin
export default {"main__about__container":"AboutCompany_main__about__container__zs4jB","main__about_company":"AboutCompany_main__about_company__8ksBt"};